/**
 * Helpers for Маркбэйс id login/register popup (window.open name + close).
 * No hardcoded tenant/user UUIDs.
 */

export const AUTH_POPUP_LOGIN_NAME = 'waysenid_login';
export const AUTH_POPUP_REGISTER_NAME = 'waysenid_register';
export const AUTH_BROADCAST_CHANNEL = 'markbase-uam-auth';

export function isAuthPopupWindow(win = window) {
  try {
    const name = String(win?.name || '');
    return name === AUTH_POPUP_LOGIN_NAME || name === AUTH_POPUP_REGISTER_NAME;
  } catch (_) {
    return false;
  }
}

/** Close popup held by opener (parent Login/Register page). */
export function closePopupRef(popupRef) {
  try {
    const w = popupRef?.current;
    if (w && !w.closed) w.close();
  } catch (_) {
    /* ignore */
  }
  if (popupRef) popupRef.current = null;
}

/** Best-effort close of the current window when it is the auth popup. */
export function closeSelfAuthPopup() {
  try {
    window.close();
  } catch (_) {
    /* browsers may block close if not script-opened — UI fallback on callback page */
  }
}
